const promiseWhrsMngt = {
    namespaced: true,
    state : {
        promiseGoodsCd : '',
        status : ''
    },
    getters: {
        getPromiseGoodsCd (state) {
            return state.promiseGoodsCd
        },
        getStatus (state) {
            return state.status
        }

    },
    mutations: {
        setPromiseGoodsCd (state, payload) {
            state.promiseGoodsCd = payload
        },
        setStatus (state, payload) {
            state.status = payload
        },


    },
    actions: {
        setPromiseGoodsCd ({commit}, payload) {
            commit('setPromiseGoodsCd', payload)
        },
        setStatus ({commit}, payload) {
            commit('setStatus', payload)
        },
        setPromiseinit ({commit}) {
            commit('setPromiseGoodsCd','');
            commit('setStatus','');
        },
    }
}


export default promiseWhrsMngt